import React from 'react'
import SearchInput from '../../../components/ui/inputs/SearchInput'

const ProspectFilters = ({ filters, onChange }) => {
  const handleInputChange = (e) => {
    onChange({ ...filters, [e.target.name]: e.target.value })
  }

  return (
    <div className="flex flex-wrap gap-2 items-center font-jost text-sm">
      <div className="w-custom500">
        <SearchInput
          name="search"
          placeholder="Pesquisar cliente..."
          value={filters.search}
          onChange={handleInputChange}
        />
      </div>
    </div>
  )
}

export default ProspectFilters
